//import { helpers } 		from './theme/helpers.js';

import { search_song } 		from './theme/components/search_song.js';
import { events } 		from './theme/components/events.js';
import { orders } 		from './theme/components/orders.js';
import { profile } 		from './theme/components/profile.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		scroll: {
			last: 0,
			min: 300,
			class: 'scrolling-down'
		}
	},
	
	init: function () {
		var self = this;

		// Global
		self.onloadClass();
		self.touch();
		self.smoothScroll.init();

		self.fakeTimeForm();
		self.plusMinusInput();

		self.copyButton();

		self.dropdown_modal();

		self.showMore();

		self.dateSecure();

		self.priceFreeEventShow();

		self.moneySlider();

		self.summaryOder();


		search_song.init();
		events.init();	
		orders.init();
		profile.init();


		document.addEventListener( 'wpcf7mailsent', function( event ) {
			let redirectUrl = "";

			if(event.detail.contactFormId == '250') {
				redirectUrl = event.detail.apiResponse.event_url + '?event=created';
			}
			else if(event.detail.contactFormId == '281' && event.detail.apiResponse.free_email != 1 ) {
				redirectUrl = window.location.href + '&order=pay&order_id=' + event.detail.apiResponse.order_id;
			}
			else if( event.detail.contactFormId == '559' || event.detail.apiResponse.free_email == 1 && event.detail.contactFormId == '281') {
				redirectUrl = window.location.href + '&order=success&order_id=' + event.detail.apiResponse.order_id;
			}
			else if( event.detail.contactFormId == '466' ) {
				redirectUrl = window.location.href;
			}
			else if( event.detail.contactFormId == '594' ) {
				redirectUrl = window.location.href;
			}
			else if( event.detail.contactFormId == '710' ) { //update event
				redirectUrl = window.location.href;
			}
			else if( event.detail.contactFormId == '585' ) { //profil usera
				redirectUrl = window.location.href;
			}

			console.log(redirectUrl);
			if( redirectUrl != "" ) {
				window.location = redirectUrl;
			}	
		}, false );


		document.querySelectorAll('[name="pass"],[name="old_pass"],[name="new_pass"] ').forEach(function(element) {
			element.type = 'password';
		});

		self.inputMaxLength();





		document.querySelectorAll('[name="variant"]').forEach(function(selectElement) {
			selectElement.addEventListener('change', function() {
			  const chooseProduct = this.closest('.choose-product');
			  if (chooseProduct) {
				const priceElement = chooseProduct.querySelector('.choose-product__price');
				if (priceElement) {
				  const price = priceElement.textContent;
				  const summarySpan = document.querySelector('.summary span:nth-of-type(2)');
				  if (summarySpan) {
					summarySpan.textContent = price + " Kč";
				  }
				}
			  }
			});
		  });




	},

	summaryOder: function() {
		document.querySelectorAll('[name="variant"]').forEach(function(selectElement) {
			selectElement.addEventListener('change', function() {
			  const chooseProduct = this.closest('.choose-product');
			  if (chooseProduct) {
				const priceElement = chooseProduct.querySelector('.choose-product__price');
				if (priceElement) {
				  const price = priceElement.textContent;
				  const summarySpan = document.querySelector('.summary span:nth-of-type(2)');
				  if (summarySpan) {
					summarySpan.textContent = price + " Kč";
				  }
				}
			  }
			});
		 });
		 document.querySelectorAll('[name="variant"]:checked').forEach(function(selectElement) {

			  const chooseProduct = selectElement.closest('.choose-product');
			  if (chooseProduct) {
				const priceElement = chooseProduct.querySelector('.choose-product__price');
				if (priceElement) {
				  const price = priceElement.textContent;
				  const summarySpan = document.querySelector('.summary span:nth-of-type(2)');
				  if (summarySpan) {
					summarySpan.textContent = price + " Kč";
				  }
				}
			  }

		 });
	},

	inputMaxLength: function() {
		const items = [
			[ '[name="name"]', 30 ],

			[ '[name="artist_name"]', 30 ],
			[ '[name="music"]', 30 ],
			[ '[name="about"]', 120 ],

			[ '[name="facebook"]', 30 ],
			[ '[name="instagram"]', 30 ],
			[ '[name="tiktok"]', 30 ],
			[ '[name="youtube"]', 30 ],
			
			[ '[name="event-name"]', 50 ],
			[ '[name="town"]', 20 ],
			[ '[name="place"]', 20 ],
		];

		jQuery.each(items, function(index, item) {
			const selector = item[0];
			const maxLength = item[1];
			
			if ( jQuery( selector ).length ) {
				jQuery(selector).attr( 'maxlength', maxLength );
			}
		});
	},

	moneySlider: function() {
		var self = this;

		if( ! document.querySelector('.js-numberSlider') ) { return; }
		
		document.querySelectorAll('.js-numberSlider').forEach(function(element) {
			let pipsValues = element.getAttribute('data-pips').split('-');
			pipsValues = pipsValues.map( value => parseInt( value ) );

			noUiSlider.create(element, {
				range: {
					'min': parseInt( element.getAttribute('data-min') ), 
					'max': parseInt( element.getAttribute('data-max') )
				},
				start: parseInt( element.getAttribute('data-start') ),
				step: parseInt( element.getAttribute('data-step') ),
				connect: 'lower',
				tooltips: {
					// tooltips are output only, so only a "to" is needed
					to: function(numericValue) {
						return numericValue.toFixed(0);
					}
				},
				pips: {
					mode: 'values',
					values: pipsValues,
					density: parseInt( element.getAttribute('data-pips-density') )
				}
			});

			element.noUiSlider.on( "update", function() {
				let numbers = 1;
				document.querySelectorAll('.noUi-tooltip').forEach(function(element) {
					numbers = numbers * element.innerText;
				});
				console.log( numbers );		
				
				numbers = numbers * 0.8;
				let year_numbers = numbers * 12;

				numbers = numbers.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
				year_numbers = year_numbers.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
				console.log( numbers);
				console.log( year_numbers );

				document.querySelector( ".js-month-money").innerText = numbers + " Kč";
				document.querySelector( ".js-year-money").innerText = year_numbers + " Kč";
			} );

		});
	},

	calculateMoney: function() {
		let numbers = 1;
		document.querySelectorAll('.noUi-tooltip').forEach(function(element) {
			numbers = numbers * element.innerText;
		});
		console.log( numbers );
	},

	priceFreeEventShow: function() {
		let freeCheckbox = document.querySelector('[name="free[]"]');

		if( freeCheckbox ) {
			freeCheckbox.addEventListener('change', function(e) {
				freeCheckbox.closest('form').querySelectorAll( '.plus-minus-input input' ).forEach(function(element) {
					element.disabled = freeCheckbox.checked;
				});
			});
		}
	},
	
	dateSecure: function() {
		function updateTimeAndDateConstraints() {
			var startDate =  document.querySelector('[name="start-date"]').value;
			var startTime = document.querySelector('[name="start-time"]').closest(".js-fakeTimeForm").querySelector("[type='time']").value;
			var endDate = document.querySelector('[name="end-date"]').value;
			var endTime = document.querySelector('[name="end-time"]').closest(".js-fakeTimeForm").querySelector("[type='time']").value;
	
			if (startDate && startTime && endDate && endTime) {
				var startDateTime = new Date(startDate + 'T' + startTime);
				var endDateTime = new Date(endDate + 'T' + endTime);

	
				if (startDateTime > endDateTime) {
					document.querySelector('[name="end-date"]').value = startDate;
					document.querySelector('[name="end-time"]').closest(".js-fakeTimeForm").querySelector("[type='time']").value = startTime;
				}
			}
	
			document.querySelector('[name="end-date"]').min = startDate;
			document.querySelector('[name="end-time"]').closest(".js-fakeTimeForm").querySelector("[type='time']").min = startTime;
		}
		if( document.querySelector('[name="start-date"]')) {
			document.querySelector('[name="start-date"]').addEventListener('change', updateTimeAndDateConstraints);
			document.querySelector('[name="start-time"]').closest(".js-fakeTimeForm").querySelector("[type='time']").addEventListener('change', updateTimeAndDateConstraints);
			document.querySelector('[name="end-date"]').addEventListener('change', updateTimeAndDateConstraints);
			document.querySelector('[name="end-time"]').closest(".js-fakeTimeForm").querySelector("[type='time']").addEventListener('change', updateTimeAndDateConstraints);
		}
	},

	dropdown_modal: function() {
		let menuOpen = document.querySelector('.js-open-header-nav');

		if( menuOpen ) {
			menuOpen.addEventListener('click', function(e) {
				e.preventDefault();
				document.querySelector( '.js-header-nav').classList.add( "active" );
			});
		}


		let closesNav = document.querySelectorAll( ".js-close-header-nav, .js-header-nav a" );
		for (let i = 0; i < closesNav.length; i++) {
			closesNav[i].addEventListener('click', function(e) {
				closesNav[i].closest( ".js-header-nav" ).classList.remove( "active" );
			});
		}

		let opens = document.querySelectorAll( ".js-open-dropdown-modal" );
		for (let i = 0; i < opens.length; i++) {
			opens[i].addEventListener('click', function(e) {
				e.preventDefault();
				opens[i].closest( ".js-dropdown-modal-parent" ).querySelector('.js-dropdown-modal').classList.add( "active" );
			});
		}

		const closes = document.querySelectorAll( ".js-close-dropdown-modal, .dropdown-modal__bg" );
		for (let i = 0; i < closes.length; i++) {
			closes[i].addEventListener('click', function(e) {
				e.preventDefault();
				closes[i].closest( ".js-dropdown-modal-parent" ).querySelector('.js-dropdown-modal').classList.remove( "active" );
			});
		}
	},

	copyButton: function() {
		if( ! document.querySelector('.js-copyLink') ) { return; }
		
		document.querySelectorAll('.js-copyLink').forEach(function(element) {
			element.addEventListener('click', function(e) {
				e.preventDefault();
				const dataCopy = this.getAttribute('data-copy');

				try {
					navigator.clipboard.writeText(dataCopy);
					
					const msgDiv = document.createElement('div');
					msgDiv.textContent = "Odkaz byl zkopírován!";
					msgDiv.classList.add("msg", "mt-2");
					this.insertAdjacentElement('afterend', msgDiv);
				
					setTimeout(() => {
						msgDiv.remove();
					}, 2000);
				} catch (err) {
					console.error('Failed to copy text: ', err);
				}
			});
		});
	},

	showMore: function() {
		if( ! document.querySelector('.show-more__controller') ) { return; }
		
		document.querySelectorAll('.show-more__controller').forEach(function(element) {
			element.addEventListener('click', function(e) {
				e.preventDefault();

				element.classList.add("d-none");

				console.log("asd");

				if( element.closest("div").querySelector( '.show-more__all' ) ) {
					console.log("asd213123");
					element.closest("div").querySelector( '.show-more__all' ).classList.remove("d-none");
				}
				
				
				element.closest(".show-more").querySelectorAll(".js-showMoreTile").forEach(function(elementt) {
					elementt.classList.remove("d-none");
				});

				element.closest(".show-more").classList.remove("show-more");
			});
		});
	},

	plusMinusInput: function() {
		const plusMinusButns = document.querySelectorAll( ".plus-minus-input .butn" );
		for (let i = 0; i < plusMinusButns.length; i++) {
			plusMinusButns[i].addEventListener("click", function( e)  {
				e.preventDefault();
					
				const step = parseInt( plusMinusButns[i].closest(".plus-minus-input").getAttribute( "data-step" ) );
				const after = plusMinusButns[i].closest(".plus-minus-input").getAttribute( "data-after" );
				const min = plusMinusButns[i].closest(".plus-minus-input").getAttribute( "data-min" );
				let value = parseInt( plusMinusButns[i].closest(".plus-minus-input").querySelector( "input" ).value.replace(/\D/g,'') );

				if (isNaN(value)) {
					value = parseInt( min );
				}

				plusMinusButns[i].closest(".plus-minus-input").querySelector( ".butn" ).classList.remove("disabled");

				if( this.innerText === "+") {
					plusMinusButns[i].closest(".plus-minus-input").querySelector( "input" ).value = value + step + after;
				} else {
					let new_value = (value - step) < min ? min : (value - step);
					plusMinusButns[i].closest( ".plus-minus-input" ).querySelector( "input" ).value = new_value + after;

					if( new_value == min ) {
						plusMinusButns[i].closest( ".plus-minus-input" ).querySelector( ".butn" ).classList.add("disabled");
					}
				}
			});
		}

		const setButns = document.querySelectorAll( "[data-set]" );
		for (let i = 0; i < setButns.length; i++) {
			setButns[i].addEventListener("click", function( e )  {
				e.preventDefault();

				const new_value = this.getAttribute("data-set");
				const after = setButns[i].closest( ".inp" ).querySelector(".plus-minus-input").getAttribute( "data-after" );
				setButns[i].closest( ".inp" ).querySelector(".plus-minus-input input").value = new_value + after
			});
		}

		const addButns = document.querySelectorAll( "[data-add]" );
		for (let i = 0; i < addButns.length; i++) {
			addButns[i].addEventListener("click", function( e )  {
				e.preventDefault();

				const old_value = parseInt( addButns[i].closest( ".inp" ).querySelector(".plus-minus-input input").value.replace(/\D/g,'') );
				let new_value = old_value + parseInt( this.getAttribute("data-add") );
				const after = addButns[i].closest( ".inp" ).querySelector(".plus-minus-input").getAttribute( "data-after" );
		
				addButns[i].closest( ".inp" ).querySelector(".plus-minus-input input").value = new_value + after
			});
		}
	},

	fakeTimeForm: function() {
		const fake_times = document.querySelectorAll( ".js-fakeTimeForm input[type='time']" );
		for (let i = 0; i < fake_times.length; i++) {
			fake_times[i].addEventListener("change", function() {
				fake_times[i].closest( ".js-fakeTimeForm" ).querySelector( "input[type='text']" ).value = fake_times[i].value;
			});
		}
	},

	// spotifySearch: function() {
	// 	// Vaše client_id a client_secret získané z Spotify Developer Dashboard
	// 	const client_id = 'YOUR_CLIENT_ID';
	// 	const client_secret = 'YOUR_CLIENT_SECRET';

	// 	// Funkce pro získání přístupového tokenu
	// 	async function getAccessToken() {
	// 	const response = await fetch('https://accounts.spotify.com/api/token', {
	// 		method: 'POST',
	// 		headers: {
	// 		'Content-Type': 'application/x-www-form-urlencoded',
	// 		'Authorization': 'Basic ' + btoa(client_id + ':' + client_secret)
	// 		},
	// 		body: 'grant_type=client_credentials'
	// 	});

	// 	const data = await response.json();
	// 	return data.access_token;
	// 	}

	// 	async function searchSong() {
	// 	const query = document.getElementById('searchQuery').value;
	// 	const accessToken = await getAccessToken();

	// 	const response = await fetch(`https://api.spotify.com/v1/search?q=${query}&type=track&limit=10`, {
	// 		headers: {
	// 		'Authorization': 'Bearer ' + accessToken
	// 		}
	// 	});

	// 	const data = await response.json();
	// 	displayResults(data.tracks.items);
	// 	}

	// 	function displayResults(songs) {
	// 	const resultsDiv = document.getElementById('results');
	// 	resultsDiv.innerHTML = ''; // Resetuje výsledky

	// 	songs.forEach(song => {
	// 		const songDiv = document.createElement('div');
	// 		songDiv.innerHTML = `
	// 		<strong>${song.name}</strong> by ${song.artists.map(artist => artist.name).join(', ')}
	// 		`;
	// 		resultsDiv.appendChild(songDiv);
	// 	});
	// 	}
	// },


	hideServiceTables: function() {
		const serviceTables = [...document.querySelectorAll('.js-serviceTable')];
		
		serviceTables.forEach(serviceTable => {
			const isVisible = serviceTable.querySelectorAll('.pricelist__tableRow:not(.d-none):not(.pricelist__tableHead)').length > 0;
			serviceTable.classList.toggle('d-none', !isVisible);
		});
	},


	calculation: function() {

		const formOptions = [...document.querySelectorAll('.wpcf7 .wpcf7-list-item .wpcf7-list-item-label')];
		formOptions.forEach(formOptions => {
			formOptions.innerHTML = formOptions.innerText;
		});

		
		document.querySelectorAll('.wpcf7-list-item input').forEach((radio) => {
			radio.addEventListener('change', function (e) {
			 	let checkedElements = this.closest( "form" ).querySelectorAll( ".wpcf7-list-item input:checked");

				let final_price = 0;
				if( checkedElements ) {
					checkedElements.forEach((item) => {
						if( item.nextElementSibling.querySelector("span") ) {
							final_price += parseInt( item.nextElementSibling.querySelector("span").innerText );
						}
					});
				}
				//this.closest( "form" ).querySelector( ".js-final-price-text" ).innerText = final_price;
				//this.closest( "form" ).querySelector( ".js-final-price-input" ).value = final_price;
		 	});
			
		});
	},

	

	checkFilters: function() {
		let self = this;
		
		const services = [...document.querySelectorAll('.pricelist__tableRow:not(.pricelist__tableHead)')];
		services.forEach(service => {
			service.classList.remove('d-none');
		});
		

		let searchText = document.querySelector('.js-pricelistSearch').value.toLowerCase();
		
		let priceSliderValues = document.querySelector('.js-priceSlider').noUiSlider.get();
		let lowPrice = parseInt( priceSliderValues[0] );
		let maxPrice = parseInt( priceSliderValues[1] );

		let searchCat = document.querySelector('.js-categorySearch').value.toLowerCase();


		services.forEach(service => {
			//text search
			if (!service.innerText.toLowerCase().includes(searchText)) {
				service.classList.add('d-none');
			}

			//prašule
			let servicePrice = parseInt( service.getAttribute("data-price") );

			if( servicePrice > lowPrice && servicePrice < maxPrice ){	
	
			}
			else {
				service.classList.add('d-none');
			}

			//categorie
			if (! service.getAttribute("data-categories").toLowerCase().includes(searchCat)) {
				service.classList.add('d-none');
			}
		});

		self.hideServiceTables();
	},


	pricelistFilter: function() {
		let self = this; 

		if( ! document.querySelector('.js-pricelistSearch') ) return;
		if( ! document.querySelector('.js-categorySearch') ) return;
		if( ! document.querySelector('.js-priceSlider') ) return;

		document.querySelector('.js-pricelistSearch').addEventListener('input', function() {
			self.checkFilters();
		});

		document.querySelector('.js-categorySearch').addEventListener('change', function() {
			self.checkFilters();
		});

		var slider = document.querySelector('.js-priceSlider');

		noUiSlider.create(slider, {
			start: [slider.getAttribute('data-start'), slider.getAttribute('data-end')],
			connect: true,
			step: 100,
			tooltips: [true, true],
			range: {
				'min': parseInt( slider.getAttribute('data-min') ),
				'max': parseInt( slider.getAttribute('data-max') )
			},
			format: wNumb({
				decimals: 0,
			})
		});

		slider.noUiSlider.on('update', function(values, handle) {
			self.checkFilters();
		});


	},




	productsSlider: function() {
		if( jQuery( '.js-productsSlider' ).length ) {
			jQuery( '.js-productsSlider:not(.tns-slider)' ).each(function() {
				var slider = tns({
					container: this,
					items: 3,
					autoplay: false,
					loop: false,
					mouseDrag: true,
					controls: true,
					nav: false,
				});
			});
	
		}
	},

	peopleSlider: function() {
		if( jQuery( '.js-peopleSlider' ).length ) {
			jQuery( '.js-peopleSlider:not(.tns-slider)' ).each(function() {
				var slider = tns({
					container: this,
					items: 4,
					autoplay: false,
					loop: false,
					mouseDrag: true,
					controls: true,
					nav: true,
				});
			});
	
		}
	},

	/* select2: function() {
		jQuery('.js-filter-country').select2();
	},

	nouislider: function() {
		var slider = document.querySelector('.js-filter-age');

		noUiSlider.create(slider, {
			start: [slider.getAttribute('data-start'), slider.getAttribute('data-end')],
			connect: true,
			step: 1,
			tooltips: [true, true],
			range: {
				'min': 16,
				'max': 26
			},
			format: wNumb({
				decimals: 0,
			})
		});

		slider.noUiSlider.on('update', function(values, handle) {
			var value = values[handle];
			if (handle) {
				document.querySelector('.js-age-max').value = value;
			} else {
				document.querySelector('.js-age-min').value = value;
			}
		});
		
	}, */

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},

	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: function (anchor, toggle) {
					var headerOffset = jQuery( '.header.header--p-fixed .header__row').outerHeight();

					if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
						headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
						headerOffset = headerOffset.replace( 'px', '');
					}

					if( !headerOffset ) {
						headerOffset = 0;
					}
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},

	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},

	onresize() {
		var self = this;
	},

	onscroll() {
		var self = this;

		const currentScroll = window.pageYOffset;

		if ( currentScroll > self.globals.scroll.last && currentScroll > self.globals.scroll.min ) {
			document.body.classList.add( self.globals.scroll.class );
		} else if ( currentScroll < self.globals.scroll.last ) {
			document.body.classList.remove( self.globals.scroll.class );
		}

		self.globals.scroll.last = currentScroll;
	},
};

jQuery(function() {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();  	
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
};
